<template>
  <div class="about">
    <h1>This is an about page</h1>
    <div class="box">box</div>
    <div class="pc-box">box</div>
  </div>
</template>

<script>
export default {
  name: 'About',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.box{
  width: 200px;
  height: 200px;
  background-color: blueviolet;
  transform: rotate(90deg);
}
.pc-box{
  width: 200px;
  height: 200px;
  background-color:blueviolet;
  transform: rotate(90deg);
}
</style>
